import React from "react";
import styles from "../../../Styles/Modules/Button.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { startAutoPlay } from "../../../State/Slices/settingsSlice";
import { playSound } from "../../../State/Slices/soundsSlice";
import { SOUND_NAME } from "../../../sounds";
import { closeModal, openModal } from "../../../State/Slices/modalSlice";

const ButtonAutoPlay = () => {
  // Initialize the dispatch function from Redux to dispatch actions
  const dispatch = useDispatch();

  // Destructure the translation function from the useTranslation hook for internationalization
  const { t } = useTranslation();

  // Extract balance and bet values from the Redux state using useSelector
  const { balance, bet } = useSelector((state) => state.game);

  // Define the handleClick function to handle button click events
  const handleClick = () => {
    // Check if the balance is sufficient to cover the bet
    if (balance >= bet) {
      // Close any open modal
      dispatch(closeModal());
      // Play a click sound
      dispatch(playSound(SOUND_NAME.click));
      // Start the auto-play feature
      dispatch(startAutoPlay());
    } else {
      // Play a sound indicating insufficient credits
      dispatch(playSound(SOUND_NAME.noCredits));
      // Open a modal to inform the user about insufficient credits
      dispatch(openModal("credit"));
    }
  };

  // Return the button element with styles and event handlers
  return (
    <button
      className={`${styles.button} ${styles.buttonStandard}`} // Apply CSS styles from the imported stylesheet
      title={t("play")} // Set the button's title attribute using the translation function
      onClick={handleClick} // Attach the handleClick function to the button's onClick event
    >
      {t("play")}
    </button>
  );
};

// Export the ButtonAutoPlay component as the default export
export default ButtonAutoPlay;
